export const ONBOARDING_STEP_IDS = {
  BUSINESS_COUNTRY: "business-country",
  MONTHLY_REVENUE: "monthly-revenue",
  BUSINESS_DETAILS: "business-details",
  CONNECTIONS_AND_DATA: "connections-and-data",
} as const;

export const ONBOARDING_SUBSTEP_IDS = {
  BUSINESS_LOCATION: "business-location",
  BUSINESS_INFORMATION: "business-information",
  BUSINESS_MODEL: "business-model",
  BANK_ACCOUNT: "bank-account",
  PLATFORMS: "platforms",
  SUSA: "susa",
  FINANCIAL_DOCUMENTS: "financial-documents",
  MANAGEMENT_ACCOUNTS: "management-accounts",
  PROFIT_AND_LOSS: "profit-and-loss",
  BALANCE_SHEET: "balance-sheet",
  DEBT_AGREEMENTS: "debt-agreement",
  REVENUE_PROJECTIONS: "cash-flow-forecast",
  SOFT_CREDIT_CHECK: "soft-credit-check",
} as const;

export const STEP_ORDER: string[] = [
  ONBOARDING_STEP_IDS.BUSINESS_COUNTRY,
  ONBOARDING_STEP_IDS.MONTHLY_REVENUE,
  ONBOARDING_STEP_IDS.BUSINESS_DETAILS,
  ONBOARDING_STEP_IDS.CONNECTIONS_AND_DATA,
];

export const ROUTE_PATHS = {
  BUSINESS_COUNTRY: "business-country",
  REVENUE: "revenue",
  BUSINESS_LOCATION: "business-location",
  BUSINESS_DETAILS: "business-details",
  BUSINESS_MODEL: "business-model",
  CONNECTIONS_BANKING: "connections/banking",
  CONNECTIONS_ADD: "connections/add",
  CONSENT_CREDIT_CHECK: "consent/credit-check",
  UPLOADS_DOCUMENT: "uploads?document=", // Dynamic path, append document type
} as const;

export const DOCUMENT_TYPE_TO_SUBSTEP = {
  susa: { id: ONBOARDING_SUBSTEP_IDS.SUSA, messageKey: "substepSusa" },
  "pool-bancario": { id: ONBOARDING_SUBSTEP_IDS.FINANCIAL_DOCUMENTS, messageKey: "substepFinancialDocuments" },
  cirbe: { id: ONBOARDING_SUBSTEP_IDS.FINANCIAL_DOCUMENTS, messageKey: "substepFinancialDocuments" },
  "management-accounts": { id: ONBOARDING_SUBSTEP_IDS.MANAGEMENT_ACCOUNTS, messageKey: "substepManagementAccounts" },
  "profit-and-loss": { id: ONBOARDING_SUBSTEP_IDS.PROFIT_AND_LOSS, messageKey: "substepProfitAndLoss" },
  "balance-sheet": { id: ONBOARDING_SUBSTEP_IDS.BALANCE_SHEET, messageKey: "substepBalanceSheet" },
  "debt-agreement": { id: ONBOARDING_SUBSTEP_IDS.DEBT_AGREEMENTS, messageKey: "substepDebtAgreements" },
  "cash-flow-forecast": { id: ONBOARDING_SUBSTEP_IDS.REVENUE_PROJECTIONS, messageKey: "substepRevenueProjections" },
} as const;

// Derived from DOCUMENT_TYPE_TO_SUBSTEP so callers stay in sync with the workflow tracker.
export function documentTypesForSubstep(substepId: string): string[] {
  return Object.entries(DOCUMENT_TYPE_TO_SUBSTEP)
    .filter(([, substepConfig]) => substepConfig.id === substepId)
    .map(([documentType]) => documentType);
}
